import React from 'react';
import { Typography, Paper, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import ReportsList from './ReportsList';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

export default function ReportsPage() {
    return (
        <>
            <Toolbar />
            <Paper sx={{ padding: '1rem', width: '97%', margin: '1rem auto' }} elevation={3}>
                <Typography variant="h4" gutterBottom>
                    Reports
                </Typography>
                <Typography variant="h6" gutterBottom>
                    Available Reports
                </Typography>
                <ReportsList />
            </Paper>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Outlet />
            </LocalizationProvider>
        </>
    );
}